import { addDays } from 'date-fns/addDays';
import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';

import type { TeamUsageMember, UsageDayCount } from '../../team.types';

export function formatDayLabel(date: string): string {
  return format(parseISO(date), 'MMM d');
}

export function formatRangeLabel(start: string, days: number): string {
  const startDate = parseISO(start.slice(0, 10));
  const endDate = addDays(startDate, days - 1);
  return `${format(startDate, 'MMM d')} – ${format(endDate, 'MMM d')}`;
}

export function deltaLabel(current: number, previous: number): string | null {
  if (previous === 0) return current > 0 ? 'New' : null;
  const delta = Math.round(((current - previous) / previous) * 100);
  return delta > 0 ? `+${delta}%` : `${delta}%`;
}

export function fillDays(
  sparse: UsageDayCount[],
  windowStart: string,
  days: number
): UsageDayCount[] {
  const countByDate = new Map(sparse.map((day) => [day.date, day.count]));
  const start = parseISO(windowStart);
  return Array.from({ length: days }, (_, offset) => {
    const day = new Date(start);
    day.setUTCDate(day.getUTCDate() + offset);
    const date = day.toISOString().slice(0, 10);
    return { date, count: countByDate.get(date) ?? 0 };
  });
}

export function activityPercentile(
  member: TeamUsageMember,
  members: TeamUsageMember[]
): number {
  const otherMembers = members.filter(
    (m) => m.membership_id !== member.membership_id
  );
  if (otherMembers.length === 0) return 0;
  const lessActiveCount = otherMembers.filter(
    (m) => m.activity_total < member.activity_total
  ).length;
  return Math.round((lessActiveCount / otherMembers.length) * 100);
}
